/** 운영자 대시보드 — 플랫폼 전체 통계 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HiOutlineBuildingStorefront, HiOutlineUsers } from 'react-icons/hi2';
import { IoEarthOutline, IoLinkOutline } from 'react-icons/io5';
import { collection, getDocs } from 'firebase/firestore';
import academyService from '../../services/academyService';
import { db } from '../../firebase/config';
import styled from 'styled-components';
import { StatGrid, StatCard, StatIcon, StatBody, Card, Empty } from '../Console/consoleUi';

const OperatorDashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [s, setS] = useState({ academies: 0, approved: 0, unclaimed: 0, users: 0, parents: 0, owners: 0 });

  useEffect(() => {
    (async () => {
      const [acads, uSnap] = await Promise.all([
        academyService.getAllAcademies(),
        getDocs(collection(db, 'users')),
      ]);
      const users = uSnap.docs.map((d) => ({ uid: d.id, ...d.data() }));
      setS({
        academies: acads.length,
        approved: acads.filter((a) => a.status === 'approved').length,
        unclaimed: acads.filter((a) => !a.ownerId || a.ownerId === '' || a.ownerId === 'demo').length,
        users: users.length,
        parents: users.filter((u) => u.accountType === 'parent' || u.role === 'parent').length,
        owners: users.filter((u) => u.accountType === 'academy').length,
      });
      setLoading(false);
    })();
  }, []);

  return (
    <>
      <Head>
        <h2>운영자 대시보드</h2>
        <p>일등급 플랫폼 전체 현황</p>
      </Head>

      <StatGrid>
        <StatCard onClick={() => navigate('/operator/academies')} style={{ cursor: 'pointer' }}>
          <StatIcon $c="#4A7CFE"><HiOutlineBuildingStorefront size={24} /></StatIcon>
          <StatBody><div className="v">{loading ? '–' : s.academies}</div><div className="l">전체 학원</div></StatBody>
        </StatCard>
        <StatCard>
          <StatIcon $c="#22C55E"><IoEarthOutline size={24} /></StatIcon>
          <StatBody><div className="v">{loading ? '–' : s.approved}</div><div className="l">디렉토리 노출중</div></StatBody>
        </StatCard>
        <StatCard>
          <StatIcon $c="#F59E0B"><IoLinkOutline size={24} /></StatIcon>
          <StatBody><div className="v">{loading ? '–' : s.unclaimed}</div><div className="l">원장 미연결</div></StatBody>
        </StatCard>
        <StatCard onClick={() => navigate('/operator/members')} style={{ cursor: 'pointer' }}>
          <StatIcon $c="#6366F1"><HiOutlineUsers size={24} /></StatIcon>
          <StatBody><div className="v">{loading ? '–' : s.users}</div><div className="l">전체 회원</div></StatBody>
        </StatCard>
      </StatGrid>

      <Card>
        <CardTitle>회원 구성</CardTitle>
        {loading ? <Empty>불러오는 중…</Empty> : (
          <Rows>
            <Row><span>학부모 계정</span><b>{s.parents}명</b></Row>
            <Row><span>학원/원장 계정</span><b>{s.owners}명</b></Row>
            <Row><span>원장 미연결 학원</span><b>{s.unclaimed}곳</b></Row>
          </Rows>
        )}
      </Card>
    </>
  );
};

export default OperatorDashboard;

const Head = styled.div`
  margin-bottom: 22px;
  h2 { font-size: 22px; font-weight: 800; color: #111827; }
  p { font-size: 13px; color: #9CA3AF; margin-top: 5px; }
`;
const CardTitle = styled.h3` font-size: 15px; font-weight: 800; color: #1F2937; margin-bottom: 14px; `;
const Rows = styled.div` display: flex; flex-direction: column; `;
const Row = styled.div`
  display: flex; align-items: center; justify-content: space-between;
  padding: 13px 4px; border-bottom: 1px solid #F1F3F7;
  &:last-child { border-bottom: none; }
  span { font-size: 14px; color: #374151; }
  b { font-size: 15px; font-weight: 800; color: #111827; }
`;
